import store from "@store/store";
import Axios from "axios";
import { getOidcAccessToken } from "@store/selectors/oidc";
import { getFilters, getOrdering, getPageSize } from "@store/selectors/pdf";
import qs from "qs";
export var HttpMethodsList;
(function (HttpMethodsList) {
    HttpMethodsList["GET"] = "GET";
    HttpMethodsList["POST"] = "POST";
})(HttpMethodsList || (HttpMethodsList = {}));
function apiRequest(url, params = {}, addParams = true, method = HttpMethodsList.GET, customHeaders = {}, data = {}) {
    const token = getOidcAccessToken(store.getState());
    const PageSize = addParams ? getPageSize(store.getState()) : {};
    const getCurrentFilters = addParams ? getFilters(store.getState()) : {};
    const getCurrentOrdering = addParams ? getOrdering(store.getState()) : {};
    return Axios({
        url: `${process.env.PDFSERVICE_API_URL}/v1${url}`,
        method,
        params: {
            PageSize,
            ...params,
            ...getCurrentFilters,
            ...getCurrentOrdering
        },
        paramsSerializer: queryParams => {
            return qs.stringify(queryParams, { arrayFormat: "repeat" });
        },
        headers: {
            Authorization: "Bearer " + token,
            ...customHeaders
        },
        data
    });
}
function fileRequest(url) {
    const token = getOidcAccessToken(store.getState());
    return Axios({
        url: `${process.env.PDFSERVICE_API_URL}/v1${url}`,
        method: "GET",
        headers: {
            Authorization: "Bearer " + token
        },
        responseType: "blob"
    });
}
export { apiRequest, fileRequest };
